module.exports = require("/tmp/build_8b9ce105/src/lib/gatsby/gatsby-browser.tsx");